import React, { Component } from 'react';
import {
  Button,
  FormGroup,
  FormInput,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'shards-react';

class ReOpenComplaint extends Component {
  state = {
    isClosingNoteEmpty: true,
  };

  render() {
    return (
      <Modal
        open={true}
        toggle={this.props.closeModal}
        backdrop={true}
        backdropClassName='backdrop'
        modalClassName='modal'
        centered={true}
        role='dialog'
      >
        <ModalHeader className='bg-primary1'>Are you sure?</ModalHeader>
        <ModalBody>Are you sure to reopen this complaint?</ModalBody>
        <ModalFooter className='home-buttons d-flex w-100 justify-content-between'>
          <Button
            theme='danger'
            type='dismiss'
            onClick={() => {
              this.props.closeModal();
            }}
          >
            Cancel
          </Button>
          <Button
            theme='success'
            type='submit'
            name='go_profile'
            onClick={() => {
              this.props.handleReOpenComplaint(this.props.complaint);
            }}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ReOpenComplaint;
